export default "__VITE_ASSET__3b1513cf__"